module.exports = __webpack_public_path__ + "img/step-9.1efd33ca.jpg";